// Importamos las dependencias necesarias
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate} from "react-router-dom";

import './App.css';
import CalculoRaices from './CalculoRaices';
import ConstantesFisicas from './ConstantesFisicas';
import TallerQF from './TallerQF'; 
import Inicio from "./Inicio";


function Navigation(){
  const location = useLocation();
  
  return (
    <div>
          <div className="app-name">
            <img src="icono1-40x40-SF.png" />
            LeAMech <span className="app-slogan">,Tools for Learn Mechanisms </span>
          </div>

              <nav>
                  <ul>

                  <li>
                          <Link to="/Inicio"  
                          className={`icon-link ${location.pathname === "/Inicio" ? "active" : ""}`}   
                          title="Inicio" >                           
                            <img src="inicio-SF-50x50.png" alt="Imagen de inicio"  />                           
                          </Link>
                      </li>

                      <li>
                          <Link to="/CalculoRaices"  
                           className={`icon-link ${location.pathname === "/CalculoRaices" ? "active" : ""}`}   
                          title="Calculadora de Ecuaciones Cuadráticas" >
                           
                            {/*Calculadora Ecuaciones Cuadráticas */}
                            <img src="iconoSolver-65x65-SF.png" alt="Imagen de parábola" /> 
                          
                          </Link>
                      </li>

                      <li>
                          <Link to="/ConstantesFisicas" 
                          className={`icon-link ${location.pathname === "/ConstantesFisicas" ? "active" : ""}`}    
                          title="Tablas con datos de constantes física usuales">
                          
                          {/*Constantes Físicas*/}
                            <img src="iconoconstantesfisicas-50X50-SF.png" alt="tablas" /> 
                            
                          </Link>
                      </li>

                      <li>
                          <Link to="/TallerQF" 
                          className={`icon-link ${location.pathname === "/TallerQF" ? "active" : ""}`}
                          title="Ejercicios de física mecánica básica" >

                            {/*Elementos de Mecánica*/}
                            <img src="IconoEjerciciosIngenieria-65x65-SF.png" alt="ejercicios" />
                            
                          </Link>
                      </li>                   
            </ul>
          </nav>

      


      </div>
  );
}

function App() {
  return (
     <Router>
          <Navigation/>
              <Routes>
              <Route path="/" element={<Navigate to="/Inicio" />} /> 
              <Route path="/Inicio" element={<Inicio  />} /> 
               <Route path="/CalculoRaices" element={<CalculoRaices  />} /> 
                <Route path="/ConstantesFisicas" element={<ConstantesFisicas />} />
                <Route path="/TallerQF" element={<TallerQF />} />                
              </Routes>   
      </Router>
  );
}

export default App;
